import dayjs from 'dayjs';
import { filter, find, get } from 'lodash';

const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export const numberFormatUtil = number => {
    let temp = parseFloat(number);
    if (temp > 999999999) {
        return `${Math.round(temp / 10000000) / 100}B`;
    }
    if (temp > 99999999) {
        return `${Math.round(temp / 1000000)}M`;
    }
    if (temp > 9999999) {
        return `${Math.round(temp / 100000) / 10}M`;
    }
    if (temp > 999999) {
        return `${Math.round(temp / 10000) / 100}M`;
    }
    if (temp > 99999) {
        return `${Math.round(temp / 1000)}K`;
    }
    if (temp > 9999) {
        return `${Math.round(temp / 100) / 10}K`;
    }
    return String(number).replace(/\B(?=(\d{3})+$)/g, ',');
};


/**
 * 是否拥有class
 *
 * @param {Object} elements -元素
 * @param {String} cName -class名称
 * @returns {Boolean}
 */
export const hasClass = function (elements, cName) {
    return !!elements.className.match(new RegExp(`(\\s|^)${cName}(\\s|$)`));
};

/**
 * 增加class
 *
 * @param {Object} elements
 * @param {String} cName
 */
export const addClass = function (elements, cName) {
    if (!hasClass(elements, cName)) {
        elements.className += ` ${cName}`;
    }
};

/**
 * 移除class
 *
 * @param {Object} elements
 * @param {String} cName
 */
export const removeClass = function (elements, cName) {
    if (hasClass(elements, cName)) {
        elements.className = elements.className.replace(new RegExp(`(\\s|^)${cName}(\\s|$)`), ' '); // replace方法是替换
    }
};

export const getBrowserType = () => {
    if (window.ActiveXObject || 'ActiveXObject' in window) return 'ie';
    if (window.navigator.userAgent.indexOf('Edge') > -1) return 'edge';
    return 'other';
};

export const scrollTo = (el, value) => {
    let type = getBrowserType();
    if (type === 'ie') {
        el.scrollTop = value;
    } else if (type === 'edge') {
        el.scrollTop = value;
    } else {
        el.scroll({
            top: value,
            left: 0,
            behavior: 'smooth'
        });
    }
};

export const transitionNumber = (count) => {
    let formatStr = numberFormatUtil(count);
    let lastChar = formatStr.slice(-1);
    if (isNaN(lastChar)) {
        return {
            count: formatStr.slice(0, formatStr.length - 1),
            unit: lastChar
        };
    }
    return {
        count: formatStr,
        unit: ''
    };
};

export function dateFormat({ value, format = 'YYYY-MM-DD' } = {}) {
    if (!value) return value;
    return dayjs(value).format(format);
}

export function getStatusTabCount(tableData, key, type) {
    const tempList = filter(tableData, item => {
        if (type === 'global') {
            return find(item.status, subItem=>{
                return get(subItem, key, 0) > 0;
            });
        }
        return get(item, key, 0) > 0;

    });
    return tempList.length;
}
